import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DonutChartComponent } from './donut-chart.component';



@NgModule({
  declarations: [
    DonutChartComponent
  ],
  imports: [
    CommonModule
  ],
  exports:[
    DonutChartComponent
  ]
})
export class DonutChartModule { }
